import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { JaaRoute } from '../../utilities/Links';

export function ContentNotFound() {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography
        variant='h1'
        sx={{
          marginBottom: 4,
        }}
      >
        {t('noContent.title')}
      </Typography>
      <Typography
        sx={{
          marginBottom: 6,
        }}
      >
        {t('noContent.content')}
      </Typography>
      <Button
        component={Link}
        to={JaaRoute.frontPage}
        size={'small'}
        variant='outlined'
        sx={{
          paddingY: 1,
          paddingX: 2,
        }}
        endIcon={<ArrowForwardIcon />}
      >
        {t('noContent.goToHomePage')}
      </Button>
    </Box>
  );
}
